module.exports = __webpack_public_path__ + "f5bb09b21438d75bd1cf0615dc1f0b48.pdf";